import React, {useEffect} from "react";
import {useAuth} from "@/app/auth/AuthContext";
import PageLoadingSpinner from "@/lib/components/PageLoadingSpinner";
import {useLocation, useNavigate} from "react-router-dom";
import {resolveSignInRedirectTarget} from "@/app/auth/signInRedirect";

export function withAuthWrapperComponent<P = any>(WrappedComponent: React.ComponentType<P>) {
    return function AuthenticatedComponent(props: P) {
        const { authenticated, loading, isLoggingOut } = useAuth();
        const navigate = useNavigate();
        const location = useLocation();

        useEffect(() => {
            if (!loading && !authenticated) {
                navigate(resolveSignInRedirectTarget(location.pathname, location.search, isLoggingOut));
            }
        }, [authenticated, loading, navigate, location, isLoggingOut]);

        if (loading) {
            return <PageLoadingSpinner />;
        }

        if (!authenticated) {
            return null;
        }

        // @ts-ignore
        return <WrappedComponent {...props} />;
    };
}
